/**
 * shop-featured.js — DenimByte
 * Handles:
 *   1. Color swatches (name → CSS colour)
 *   2. Wishlist (localStorage toggle)
 *   3. "Add to Bag" (Shopify AJAX cart API)
 *   4. Cart count badge update in header
 */

(function () {
  'use strict';

  /* ════════════════════════════════════════════
     1. COLOR SWATCH MAP
        Converts Shopify option value names to CSS colours.
        Falls back to treating the name as a CSS named colour.
     ════════════════════════════════════════════ */
  var COLOR_MAP = {
    black:    '#1a1a1a',
    white:    '#f5f5f0',
    brown:    '#8B4513',
    tan:      '#D2B48C',
    cognac:   '#9E5330',
    burgundy: '#800020',
    wine:     '#722F37',
    red:      '#CC2200',
    navy:     '#000080',
    blue:     '#1D4ED8',
    grey:     '#808080',
    gray:     '#808080',
    charcoal: '#36454F',
    cream:    '#FFF8DC',
    ivory:    '#FFFFF0',
    beige:    '#F5F5DC',
    camel:    '#C19A6B',
    khaki:    '#C3B091',
    olive:    '#6B7645',
    green:    '#228B22',
    yellow:   '#FFC107',
    orange:   '#E85D04',
    pink:     '#F472B6',
    purple:   '#7C3AED',
  };

  function applySwatchColors() {
    document.querySelectorAll('.shop-pcard__swatch[data-color]').forEach(function (el) {
      var name = (el.getAttribute('data-color') || '').toLowerCase().trim();
      el.style.backgroundColor = COLOR_MAP[name] || name;
    });
  }

  /* ════════════════════════════════════════════
     2. WISHLIST (localStorage)
     ════════════════════════════════════════════ */
  var WISHLIST_KEY = 'dbWishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); }
    catch (e) { /* storage full */ }
  }

  function isWishlisted(productId) {
    return getWishlist().indexOf(String(productId)) !== -1;
  }

  function toggleWishlist(productId) {
    var list = getWishlist();
    var id   = String(productId);
    var idx  = list.indexOf(id);
    if (idx === -1) list.push(id); else list.splice(idx, 1);
    saveWishlist(list);
    return idx === -1; /* true = now wishlisted */
  }

  function initWishlistButtons() {
    document.querySelectorAll('.shop-pcard__wishlist[data-product-id]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      if (isWishlisted(id)) btn.classList.add('is-wishlisted');

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var nowWishlisted = toggleWishlist(id);
        btn.classList.toggle('is-wishlisted', nowWishlisted);
        btn.setAttribute('aria-label', nowWishlisted ? 'Remove from wishlist' : 'Add to wishlist');
        /* Brief visual confirmation */
        btn.style.transform = 'scale(1.3)';
        setTimeout(function () { btn.style.transform = ''; }, 200);
      });
    });
  }

  /* ════════════════════════════════════════════
     3. ADD TO BAG (Shopify AJAX cart API)
     ════════════════════════════════════════════ */
  function updateHeaderCartCount(count) {
    /* Update any cart badge in the shop header */
    document.querySelectorAll('.shop-nav__badge').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
    /* Update any cart link aria-label */
    document.querySelectorAll('[aria-label*="Shopping bag"]').forEach(function (el) {
      el.setAttribute('aria-label', 'Shopping bag, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  function showAddFeedback(btn, success) {
    var original = btn.innerHTML;
    if (success) {
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg> Added!';
      btn.style.background = '#16a34a'; /* green confirm */
    } else {
      btn.innerHTML = 'Error — try again';
      btn.style.background = '';
    }
    setTimeout(function () {
      btn.innerHTML = original;
      btn.style.background = '';
      btn.disabled = false;
    }, 1800);
  }

  function initAddToCart() {
    document.querySelectorAll('.shop-pcard__add-btn[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (btn.disabled) return;
        btn.disabled = true;

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:    JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
        })
          .then(function (resp) {
            if (!resp.ok) throw new Error('cart error');
            return resp.json();
          })
          .then(function () {
            showAddFeedback(btn, true);
            /* Refresh cart count */
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          })
          .then(function (resp) { return resp.json(); })
          .then(function (cart) { updateHeaderCartCount(cart.item_count); })
          .catch(function () {
            showAddFeedback(btn, false);
          });
      });
    });
  }

  /* ════════════════════════════════════════════
     INIT
     ════════════════════════════════════════════ */
  function init() {
    applySwatchColors();
    initWishlistButtons();
    initAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
